import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WinterHoardParsedGameData, WinterHoardParsedInitData} from "./data/IWinterHoardServerData";
import {WinterHoard} from "../WinterHoard";

export class FeaturePrice {
    private _initData: WinterHoardParsedInitData;
    private _gameData: WinterHoardParsedGameData;

    constructor() {
        this.addEventListeners();
    }

    public getBuyFeaturePrice(playedBetVal?: number, wasFeatureBuy?: boolean): number {
        const betLevel: string = WinterHoard.api.freeBets.hasFreeBets() ? WinterHoard.api.freeBets.getBet() : WinterHoard.api.betLevel.getLevel();
        let price: number = playedBetVal ? playedBetVal : (WinterHoard.model.gameData?.playedBetValue || parseFloat(betLevel));

        const activeFeature = WinterHoard.api.betFeatureController.getActiveBetFeature();
        if (activeFeature) {
            price = activeFeature.getTotalCost();
        }
        return price;
    }

    public isWinBelowStake(): boolean {
        return WinterHoard.api.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBuyFeaturePrice());
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onGameDataParsed(data: WinterHoardParsedGameData): void {
        this._gameData = data;
    }

    private onInitDataParsed(data: WinterHoardParsedInitData): void {
        this._initData = data;
    }

    private getAccumulatedRoundWin(): number {
        return +(this._gameData?.accumulatedRoundWin || this._initData.accumulatedRoundWin);
    }
}